import { FunctionComponent, MouseEventHandler, useContext, useState } from 'react'
import styled, { ThemeContext } from 'styled-components'

import Minus from 'components/SVG/Minus'
import Plus from 'components/SVG/Plus'
import LinkIcon from 'components/SVG/compound/Link'
import Spacer from 'components/Spacer'

import * as T from './types'

const EntryContainer = styled.div<T.IExpandedProps>`
  max-height: ${props => (props.expanded ? 1000 : 100)}px;
  transition: max-height 150ms;
`

const LinkContainer = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;

  transition: opacity 0.2s ease-in;
`

const EntryHeading = styled.div`
  display: flex;
  cursor: pointer;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;

  :hover > div {
    opacity: 1;
  }
`

const ExpandedIconContainer = styled.div<T.IExpandedProps>`
  width: 24px;
  height: 24px;
  font-size: 24px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => props.theme.colors[props.expanded ? 'grey6' : 'purple']};
  flex-shrink: 0;
  margin: 0 10px 0 20px;
  border-radius: 4px;
  transition: background-color 150ms;
`

const EntryText = styled.p`
  margin: 0;
  padding-left: 54px;
`

const Entry: FunctionComponent<T.IEntryProps> = ({ entry, last, queryAnchor }) => {
  const theme = useContext(ThemeContext)

  const [expanded, setExpanded] = useState(entry.anchor === queryAnchor)
  const toggleEntry = (): void => setExpanded(!expanded)

  const handleCopy: MouseEventHandler<HTMLDivElement> = event => {
    event.preventDefault()
    event.stopPropagation()

    if (typeof window === 'undefined') return

    const hostname
      = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : window.location.hostname

    navigator.clipboard.writeText(`${hostname}/faq/#${entry.anchor}`)
  }

  return (
    <>
      <EntryContainer
        key={entry.anchor}
        expanded={expanded}
        id={entry.anchor}
      >
        <EntryHeading onClick={() => toggleEntry()}>
          <ExpandedIconContainer expanded={expanded}>
            {expanded && (
              <Minus
                width={14}
                height={2}
                fill={theme.colors.white}
              />
            )}
            {!expanded && (
              <Plus
                width={14}
                height={14}
                fill={theme.colors.white}
              />
            )}
          </ExpandedIconContainer>
          {entry.heading}
          <Spacer size={theme.spacings[4]} />
          <LinkContainer onClick={handleCopy}>
            <LinkIcon
              width={14}
              height={14}
              fill={theme.colors.neutral900}
            />
          </LinkContainer>
        </EntryHeading>
        {expanded && <Spacer size={5} />}
        <EntryText dangerouslySetInnerHTML={{ __html: `${expanded ? entry.content : ''}` }} />
      </EntryContainer>
      <Spacer size={last ? 20 : 15} />
    </>
  )
}

export default Entry
